import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { SpecialLabel } from '../types/special-label';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteSpecialLabelService extends IApiBackendRouteService {
  urlRoute = `${API_ENDPOINTS.LABELS}/special`;

  getAll(): Observable<SpecialLabel[]> {
    return this.http.get<SpecialLabel[]>(`${this.urlRoute}`);
  }

  add(body: {
    title: string;
    shouldHavePartNumber: boolean;
  }): Observable<SpecialLabel> {
    return this.http.post<SpecialLabel>(`${this.urlRoute}`, { ...body });
  }
}
